import { fetchListRedundancyPaymentGateway } from './../../../requests'

export async function isRedundancyPaymentGateway(params, resource) {
  console.log(6234958776, { method: 'getList', resource: resource, params: params })
  const { page, perPage } = params.pagination

  const [, data] = await fetchListRedundancyPaymentGateway({ page, perPage })
  return { data: data.rows, total: data.count }
}
